import React, { FC, HTMLAttributes, ReactNode, useState } from 'react'
import AccordionItem from './AccordionItem'
import styles from './Accordion.module.scss'

export type AccordionItemType = {
  title: string
  content: ReactNode
}

type AccordionProps = {
  items: ReadonlyArray<AccordionItemType>
  containerCustomStyle?: string
  headerCustomStyle?: string
  contentCustomStyle?: string
  itemCustomStyle?: string
  CustomIcon?: React.ReactElement<HTMLAttributes<SVGElement>>
}

const Accordion: FC<AccordionProps> = ({
  items,
  containerCustomStyle,
  headerCustomStyle,
  contentCustomStyle,
  itemCustomStyle,
  CustomIcon,
}) => {
  const [activeIndex, setActiveIndex] = useState<ReadonlyArray<string>>([])

  const handleChangeIndex = (index) => {
    setActiveIndex((prevValue) => {
      if (prevValue.includes(index)) {
        return prevValue.filter((indexToFilter) => indexToFilter !== index)
      } else {
        return [...prevValue, index]
      }
    })
  }

  return (
    <div className={`${styles.accordionContainer} ${containerCustomStyle || ''}`} data-style='accordion-container'>
      {items.map((item, index) => (
        <AccordionItem
          key={index.toString()}
          title={item.title}
          headerCustomStyle={headerCustomStyle}
          contentCustomStyle={contentCustomStyle}
          itemCustomStyle={itemCustomStyle}
          activeIndex={activeIndex}
          onChangeIndex={handleChangeIndex}
          CustomIcon={CustomIcon}
        >
          {item.content}
        </AccordionItem>
      ))}
    </div>
  )
}

export default Accordion
